(ns com.theplantscape.plant-web.pages.plant-calendar
  (:require
   [tick.core :as t]
   [clojure.string :refer [lower-case] :as str]
   [cljs.core.async :refer [<! go]]
   [com.theplantscape.plant-web.draw.api :refer [wrap-response]]
   [com.theplantscape.local-store.ensemble :as db]
   [com.theplantscape.plant-web.draw.db-store :refer [restore-database restore-remote-diagram]]
   [com.theplantscape.plant-web.api.diagrams
    :refer [fetch-user-diagram fetch-user-diagram-async]]
   [com.theplantscape.plant-web.api.plants :refer [fetch-plants-async]]
   [com.theplantscape.local-store.ensemble :refer [placed-plant-eids]]
   [com.theplantscape.plant-web.draw.state :refer [site-state site-data]]
   [reagent.core :as r]
   [reitit.frontend.easy :as rfe]))


(defn tab-button [{:keys [text selected on-click]}]
  [:li.me-2
   [:a.inline-block.p-4.rounded-t-lg
    
    {:class (if selected
              "text-blue-600 bg-gray-100 active dark:bg-gray-800 dark:text-blue-500"
              "hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300")
     :on-click #(on-click)
     :href "#" :aria-current "page"} text]]
  )
164201
(defn ui-tabs [tabs on-click]
  (into 
   [:ul.flex.flex-wrap.text-sm.font-medium.text-center.text-gray-500.border-b.border-gray-200.dark:border-gray-700.dark:text-gray-400]
   (map tab-button tabs)
      ))



(defn init-calendar-page [{:keys  [diagram-id]}]
  (prn "init calendar")
  (go
    (let [diagram (<! (fetch-user-diagram-async
                       diagram-id))]
      (wrap-response
       diagram
       (partial restore-remote-diagram db/diag diagram-id)
       (prn "failed to get calendar diagram"))
      #_(restore-remote-diagram db/diag diagram-id
                              (second diagram))
      (prn "fetch plants")
      (prn (mapv :plant/id (placed-plant-eids))))
    (let [result (<! (fetch-plants-async (mapv :plant/id (placed-plant-eids))))]
      (prn "fetch plants")
      (swap! site-data assoc-in [:page :calendar :plants] (second result)))))

(defn fetch-page-plants [ids]
  (go (let [result (<! (fetch-plants-async ids))]
        (swap! site-data assoc-in [:page :calendar :plants] result))))

#_(defn init-calendar-plants []

    (fetch-plants-async))

(def months
  [{:key :january
    :number 1
    :name "January"
    :short "Jan"}
   {:key :feburary
    :number 2
    :name "Feburary"
    :short "Feb"}
   {:key :march
    :number 3
    :name "March"
    :short "Mar"}
   {:key :april
    :number 4
    :name "April"
    :short "Apr"}
   {:key :may
    :number 5
    :name "May"
    :short "May"}
   {:key :june
    :number 6
    :name "June"
    :short "Jun"}
   {:key :july
    :number 7
    :name "July"
    :short "Jul"}
   {:key :august
    :number 8
    :name "August"
    :short "Aug"}
   {:key :september
    :number 9
    :name "September"
    :short "Sep"}
   {:key :october
    :number 10
    :name "October"
    :short "Oct"}
   {:key :november
    :number 11
    :name "November"
    :short "Nov"}
   {:key :december
    :number 12
    :name "December"
    :short "Dec"}])

(defn select-cells
  "Loop over months return x on month start continuing until month end else return nil in the sequence"
  [start end months]
  (prn "select cells")
  (loop [in-range false
         mark nil
         month months
         result []]
    (prn result)
    (if (seq month)
      (cond (= (first month) (keyword start))
            (recur true "x" (rest month) (conj result {:text "x" :position :start}))
            (= (first month) (keyword end))
            (recur false "x" (rest month) (conj result {:text "x" :position :end} ))
            :else
            (recur in-range (when in-range mark) (rest month) (conj result {:text mark :position
                                                                            (if in-range :middle :outside)})))
      result)))

(defn ui-calendar-months-row-marked
  ([cells] (ui-calendar-months-row-marked "" "" cells))
  ([title cells] (ui-calendar-months-row-marked title "" cells))
  ([title classes cells]
   (into [:div.flex
          [:div.w-48.shrink-0.text-left title]]
         (mapv (fn months [month]
                 [:div.border.w-10.h-8.p-0.shrink-0.flex-none
                  {:class (if (:text month) (str
(str
                             (case (:position month)
                               :start "bg-red-500 rounded-l-lg"
                               :end "bg-red-500 rounded-r-lg"
                               :middle "bg-red-500"
                               " ")
                              classes)
                                    (str " " (:position month))  ) classes)}
                  [:div.m-auto.align-middle (:text month)
                   ]])
               cells))))

(defn ui-calendar-months-row
  ([cells] (ui-calendar-months-row "" cells))
  ([classes cells]
   (into [:div.flex [:div.w-48.shrink-0.text-left " "]]
         #_[:span.flex.justify-center.items-center.mb-2.mt-2.sm:m-2]
         (mapv (fn months [month]
                 [:div.border.w-10.h-14.p-0.shrink-0
                  {:class classes
                   :style {"writingMode" "vertical-rl"
                           :text-orientation "mixed"}}
                  month])
               cells))))

(defn ui-definition-list [items]
  (into [:dl.ml-4] (->> items
                        (mapv (fn definition-item [[type name]]
                                (when name
                                  [:div {:key type}
                                   [:dt.inline.font-bold.w-12 (str type ":")]
                                   [:dd.inline.ml-2 name]])))
                        (remove nil?)
                        vec)))

(defn ui-calendar-months-row-header-old [cells]
  [ui-calendar-months-row "border-green-500 text-green-500" cells])

(defn ui-calendar-item [type {:keys [plant/id plant/common-name :plant/scientific-name] :as item}]
  [:<>
   ;;[:p (str item)]
   [:div.justify-center.items-center.m-2:md.grow
    [:a.link.dt.w-100.bb.b--black-10.pb2.mt2.dim.blue
     {:href (rfe/href :plant {:plant-id id})}
     [:div.col-span-2 [:span common-name] " - " [:span scientific-name]]
     [ui-definition-list
      [;;["season" season]
       ["Layer" (:plant/type item)]
       ["Lifecycle" (:plant/lifecycle item)]
       ["Family" (:plant/family item)]]]

     #_[:div.dtc.w3
        [:img.db.w-96 {:src "https://plants.digitaloctave.com/images/default.jpg"}]]]]

   [:div.flex.flex-col.text-center.mb-2.mt-2.w-100
    [ui-calendar-months-row-marked "Sowing"
     (select-cells
      (-> item :plant.season/sowing :start)
      (-> item :plant.season/sowing :end)
      (mapv :key months))]
    [ui-calendar-months-row-marked "Planting"
     (select-cells
      (-> item :plant.season/planting :start)
      (-> item :plant.season/planting :end)
      (mapv :key months))]
    [ui-calendar-months-row-marked "Flowering"
     (select-cells
      (-> item :plant.season/flowering :start)
      (-> item :plant.season/flowering :end)
      (mapv :key months))]
    [ui-calendar-months-row-marked "Harvesting"
     (select-cells
      (-> item :plant.season/harvesting :start)
      (-> item :plant.season/harvesting :end)
      (mapv :key months))]]])

(defn ui-calendar-row [children]
  (into [:div ;;.grid.border-b.border-red-500
         #_{:class "grid-flow-col  grid-cols-2 lg:grid-cols-1 gap-4"}]
        children))

(defn ui-calendar [type items]
  (let [plants (r/cursor site-data [:page :calendar :plants])]
    (fn [type items]
      [:main.grid.lg:grid-cols-2.grid-cols-1.gap-4.mw6.center.text-xs.md:text-lg
                [:div " "]
       [ui-calendar-months-row "" (mapv :short months)]
       #_[:div.flex
          [:div.w-48] 
          ]
       #_[ui-calendar-row
        [#_[:span.justify-bottom.items-center.m-2.grow
          [:span.p-4 "Name"]
          [:span.p-4 "Type"]]
         [:div " "]
         [:div.flex
          [:div.w-48] 
          [ui-calendar-months-row "" (mapv :short months)]]]]

       (map
        (fn [item]
          [:<> {:key (:xt/id item)}
           [ui-calendar-item type item]
           #_[ui-calendar-row
            [[ui-calendar-item type item]]
            ]
           ])

        @plants #_items)])))

(defn ui-calendar-schedule-card [txt plants]
  (let [weeks (t/between
               (t/date)
               txt
               :weeks)
        month-plants (get plants (keyword (lower-case (str (t/month txt)))))]
    (when month-plants
      [:div
       [:a.block.max-w-sm.p-6.bg-white.border-t-2.border-r-4.border-l-4.border-gray-200.shadow-sm.hover:bg-gray-100.dark:bg-gray-800.dark:border-gray-700.dark:hover:bg-gray-700 {:href "#"}

        [:h5.mb-2.text-xl.font-bold.tracking-tight.text-gray-900.dark:text-black
         " "
         (str (if (zero? weeks) "now" (str weeks " week time"))
              " in " (lower-case (str (t/month txt))))
         (into [:dl.font-normal.text-gray-700.dark:text-gray-400]
               (reduce (fn [l p]
                         (-> l
                             (conj
                              [:dt (:plant/scientific-name p) " - " (:plant/common-name p)]
                              [:dd
                               (cond
                                 (:start (:plant.season/sowing p))
                                 (str "Sowing between "
                                      (:start (:plant.season/sowing p)) " "
                                      (:end (:plant.season/sowing p)))
                                 (:start (:plant.season/planting p)) 
                                 (str "Planting between "
                                      (:start (:plant.season/planting p)) " "
                                      (:end (:plant.season/planting p)))
                                 (:start (:plant.season/fruiting p)) 
                                 (str "Harvesting between "
                                      (:start (:plant.season/fruiting p)) " "
                                      (:end (:plant.season/fruiting p)))
                                 (:start (:plant.season/harvesting p)) 
                                 (str "Harvesting between "
                                      (:start (:plant.season/harvesting p)) " "
                                      (:end (:plant.season/harvesting p)))
                                 (:start (:plant.season/flowering p)) 
                                 (str "Flowering between "
                                      (:start (:plant.season/flowering p)) " "
                                      (:end (:plant.season/flowering p)))
                                 :else "temporary")  ]

                              #_[:dd (str p)])))
                       []
                       month-plants
                       #_(get plants weeks)))]]])))

(defn ui-calendar-schedule [plants]
  [:div
   #_(str (reduce (fn [m p]
                  (update m (-> p :plant.season/fruiting :start keyword) conj p)) {} plants))
   (into [:div]
         (map (fn [date]
                [ui-calendar-schedule-card date
                 (reduce (fn [m p]
                           (update m (-> p :plant.season/fruiting :start keyword) conj p)) {} plants)])
              (t/range
               (t/date)
               (t/>> (t/date)
                     (t/new-period 12 :months))
               (t/new-period 2 :weeks))))])

;; [diagram (r/cursor site-data [:datalog-queries :boundary]) 
;;         area (r/cursor site-data [:datalog-queries :area])
;;         structure (r/cursor site-data [:datalog-queries :structure]) 
;;         path (r/cursor site-data [:datalog-queries :path])
;;         canopy (r/cursor site-data [:datalog-queries :canopy ]) 
;;         tree (r/cursor site-data [:datalog-queries :sub-canopy ]) 
;;         shrub (r/cursor site-data [:datalog-queries :shrub ]) 
;;         herbaceous (r/cursor site-data [:datalog-queries :herbaceous])
;;         ground (r/cursor site-data [:datalog-queries :ground]) 
;;         root (r/cursor site-data [:datalog-queries :root]) 
;;         vine (r/cursor site-data [:datalog-queries :vine])
;;         plant (r/cursor site-data [:datalog-queries :plant])

(defn ui-page-schedule [{:keys [path] :as route}]
  (let [current-tab (r/atom 1)
        search (r/atom "")
        document (r/cursor site-state [:document])
        latest (r/cursor document [:body])
        meta (r/cursor document [:details])
        plants (r/cursor site-data [:page :calendar :plants])]
    (fn []
      [:<>
       ;; (str @site-data)
       ;; (str (placed-plant-eids))
       [:div.w-100
        [ui-tabs
         [{:text "Upcoming tasks"
           :selected true
           :on-click #(reset! current-tab 1)}
          {:text "Yearly calendar"
           :selected false
           :on-click #(reset! current-tab 2)}]]
        (if (= @current-tab 1)
          [:div.m-4 [ui-calendar-schedule @plants]]
          [:div.m-4 [ui-calendar "test" @plants]])]])))
